import React from "react";
import Button from "../../../../../_components/Button";
import IconButton from "../../../../../_components/IconButton";
import Modal from "../../../../../_components/Modal";
import Toast from "../../../../../_components/Toast";
import Text from "../../../../../_components/Text";
import { _Input } from "../../../../../_components/Input";
import styled, { css } from "styled-components";

import * as colors from "../../../../../assets/_base/colors";

import {
  readBase64Image,
  CreateTransaction,
} from "../../../../../api/financial";
import { useDisplayStringLimit } from "./hooks";

const ImagePrompContainer = styled.div`
  background-color: #ebebeb;
  ${(props) => {
    if (props.loading) {
      return css`
        opacity: 0.4;
        cursor: not-allowed;
      `;
    }
  }}
  display: flex;
  justify-content: space-between;
  padding: 15px;
  align-self: baseline;
  align-items: baseline;
  border-radius: 40px;
  @media (max-width: 600px) {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 5px;
    padding-rigth: 5px;
  }
`;
const ImagePrompContainerItem = styled.div`
  background-color: #ebebeb;
  display: flex;
  justify-content: space-between;
  padding: 5px;
  align-self: center;
`;

const ImagePrompContainerItemInner = styled.div`
  padding: 10px;
  background-color: ${colors.lightBlue} !important;
  margin-left: 10px;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 600px) {
    padding: 3px;
    border-radius: 7px;
  }
`;
function CameraInput({ onCapture }) {
  const [imageSrc, setImageSrc] = React.useState("");

  const handleImageSelection = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result);
        if (typeof onCapture === "function") {
          onCapture(reader.result, file.name);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  function handleClick() {
    try {
      document
        .getElementById("input-get-image-to-import-with-gpt-vision")
        .click();
    } catch (error) {}
  }
  return (
    <div>
      <input
        className="d-none"
        type="file"
        accept="image/*"
        onChange={handleImageSelection}
        id="input-get-image-to-import-with-gpt-vision"
      />
      <Button onClick={handleClick}>
        Importar com IA &nbsp;&nbsp;
        <img
          width={15}
          src="https://www.gstatic.com/lamda/images/favicon_v1_70c80ffdf27202fd2e84f.png"
        />
      </Button>
    </div>
  );
}

export default (props) => {
  const limitDisplayString = useDisplayStringLimit();
  const [show, setShow] = React.useState(false);
  const [data, setData] = React.useState({});
  const [paymentMethods, setPaymentMethods] = React.useState([
    {
      value: "4bf2b774-3476-49fc-bb26-591e363a415d",
      label: "Dinheiro",
    },
    {
      value: "2f903e2c-3f25-43aa-81e4-3a803f779a91",
      label: "Cartão de Crédito",
    },
    {
      value: "30611e18-d7e9-455b-8c79-4874e45bd9e8",
      label: "Cartão de Débito",
    },
    {
      value: "66d2e0bb-cd7a-41b1-9422-f955b8aca0d2",
      label: "Transferência Bancária",
    },
    {
      value: "85b486e2-1cfb-4b09-ae36-6c53c93984a2",
      label: "Boleto Bancário",
    },
    {
      value: "8c98684f-3dfd-4366-9611-849a37f36c51",
      label: "Programa de fidelidade, Cashback, Crédito Virtual",
    },
    {
      value: "fdf93dcb-3352-439e-85b9-4fac221b9b92",
      label: "PIX",
    },
    {
      value: "bae3bb3c-6836-4583-94de-b53872d309cc",
      label: "Sem Pagamento",
    },
  ]);
  const [toast, setToast] = React.useState({});
  const [transacation, setTransaction] = React.useState({ payment: {} });
  const [loading, setLoading] = React.useState(false);

  const handleImageSelection = (imageData, filename) => {
    setData({
      img64: imageData,
      filename,
    });
    setShow(true);
  };

  function openFinder() {
    try {
      document
        .getElementById("input-get-image-to-import-with-gpt-vision")
        .click();
    } catch (error) {}
  }
  function onHide() {
    setShow(false);
    setTransaction({ payment: {} });
  }
  function onRead() {
    setToast({});
    setLoading(true);
    setToast({ type: "", show: false });
    readBase64Image(data)
      .then((response) => {
        if (!response.success) {
          setToast({
            type: "info",
            show: true,
            message: "IA: Alguns dados não foram identificados!",
          });
        }
        try {
          if (!response.payment.due_date) {
            const date = new Date();

            response.payment.due_date = `${date.getFullYear()}-${
              date.getMonth() + 1
            }-${date.getDate()}`;
          } else {
            const dateArray = response.payment.due_date.split("-");
            const date = new Date();
            date.setFullYear(dateArray[0]);
            date.setDate(dateArray[2]);
            response.payment.due_date = response.payment.due_date;
          }
        } catch (error) {
          console.error("IAError", error);
        }
        setShow(false);
        setPaymentMethods(
          paymentMethods.map((item) => {
            return {
              ...item,
              selected: response.payment.payment_method === item.value,
            };
          })
        );
        setTimeout(() => {
          setShow(true);
        }, 300);
        setTransaction({
          ...response,
          cost_type: 1,
          type: 2,
        });
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 1000);
      }).catch((err) => {
        if(typeof(err) === "object"){
          setToast({ show: true, message: `on Read ${JSON.stringify(err)}` })
        }else{
          setToast({ show: true, message: `on Read ${err}` })
        }
      });
  }
  function create() {
    setToast({});
    if (!transacation.payment.due_date) {
      setToast({ message: "Informe uma data válida", show: true });
      return;
    }
    if (!transacation.description) {
      setToast({ message: "Informe a descrição", show: true });
      return;
    }
    setLoading(true);
    CreateTransaction({
      ...transacation,
      payment: {
        value: transacation.payment.value,
        payment_method: transacation.payment.payment_method,
        due_date: transacation.payment.due_date,
      },
    })
      .then((resp) => {
        setToast({ show: true, message: "Recibo importado!", type: "success" });
        setTimeout(() => {
          location.reload();
        }, 2000);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 2500);
      })
      .catch((err) => setToast({ show: true, message: `Create ${err}` }));
  }

  return (
    <div>
      <CameraInput onCapture={handleImageSelection} />
      <Modal title="Importar Contas a Pagar com IA" show={show} onHide={onHide}>
        <div className="container">
          <div className="row">
            <div className="row">
              <div
                className={transacation.type ? "col-md-4 col-xs-12" : "d-none"}
              >
                <div className="form-group">
                  <div className="form-label">Valor</div>
                  <_Input
                    value={transacation.payment.value}
                    type="currency"
                    onChange={(e) =>
                      setTransaction({
                        ...transacation,
                        payment: {
                          ...transacation.payment,
                          value: e.value,
                        },
                      })
                    }
                  />
                </div>
              </div>
              <div
                className={transacation.type ? "col-md-4 col-xs-12" : "d-none"}
              >
                <div className="form-group">
                  <div className="form-label">Vencimento</div>
                  <_Input type="date" value={transacation.payment.due_date} />
                </div>
              </div>
              <div
                className={
                  transacation.payment.payment_method_name
                    ? "col-md-4 col-xs-12"
                    : "d-none"
                }
              >
                <div className="form-group">
                  <div className="form-label">Pagamento</div>
                  <_Input type="select" options={paymentMethods} />
                </div>
              </div>
              <div
                className={
                  transacation.payment.payment_method_name
                    ? "col-md-4 col-xs-12"
                    : "d-none"
                }
              >
                <div className="form-group">
                  <div className="form-label">Descrição</div>
                  <_Input
                    disabled={loading}
                    value={transacation.description}
                    onChange={(e) =>
                      setTransaction({
                        ...transacation,
                        description: e.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="col-12 mx-auto">
              <ImagePrompContainer loading={loading}>
                <ImagePrompContainerItem>
                  <IconTextButton
                    loading={loading}
                    onClick={() => {
                      setData({
                        img64: null,
                        filename: null,
                      });
                      setTransaction({ payment: {} });
                    }}
                    title="remover recibo"
                    text="Remover recibo"
                    icon="trash-alt"
                  />
                  <IconTextButton
                    loading={loading}
                    onClick={() => {
                      setTransaction({ payment: {} });
                      setData({
                        img64: null,
                        filename: null,
                      });
                      openFinder();
                    }}
                    title="Editar recibo"
                    text="Editar recibo"
                    icon="edit"
                  />
                </ImagePrompContainerItem>
                <ImagePrompContainerItem>
                  <Text color="primary">
                    {limitDisplayString(
                      data.filename,
                      window.screen.width < 600 ? 25 : 50
                    )}
                  </Text>
                </ImagePrompContainerItem>
                <ImagePrompContainerItem>
                  <IconTextButton
                    onClick={
                      data.filename
                        ? transacation.payment.payment_method_name
                          ? create
                          : onRead
                        : openFinder
                    }
                    title={
                      data.filename
                        ? transacation.payment.payment_method_name
                          ? "Salvar"
                          : "Enviar Recibo"
                        : "Selecionar recibo"
                    }
                    icon={`fas ${
                      data.filename ? "fa-paper-plane" : "fa-file-upload"
                    }`}
                    text={data.filename ? "Enviar Recibo" : "Selecionar recibo"}
                  />
                </ImagePrompContainerItem>
              </ImagePrompContainer>

              {loading?
              <i class="fas fa-spinner fa-pulse fa-2x mt-2 d-flex justify-content-center align-items-center"></i> 
              
              : <React.Fragment/>}
                  
            </div>
          </div>
        </div>
      </Modal>
      <Toast {...toast} />
    </div>
  );
};

function IconTextButton(props) {
  return (
    <ImagePrompContainerItemInner
      onClick={props.loading === true ? null : props.onClick}
      title={`${props.title}`}
    >
      <IconButton
        onClick={props.loading ? null : props.onClick}
        className="text-white"
        icon={`${props.icon}`}
      />
      <Text
        fontSize=".8em"
        color="white"
        className="d-none d-md-block d-lg-block"
      >
        {props.text}
      </Text>
    </ImagePrompContainerItemInner>
  );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/components/ImportWithGPTVision/index.jsx